import * as Types from "../../../../../types/__generated__/graphql";

import {gql} from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type LocationFragment = {
  __typename?: "BookableLocation";
  id: string;
  slug?: string | null;
  name?: string | null;
  timezone?: string | null;
  phoneNumber?: string | null;
  isOpen?: boolean | null;
  locationAddress?: {
    __typename?: "BookableLocationAddress";
    id: string;
    longitude?: number | null;
    latitude?: number | null;
    address?: {
      __typename?: "Address";
      street?: string | null;
      street2?: string | null;
      zipcode?: string | null;
      state?: Types.UsStateAbbreviation | null;
      city?: string | null;
    } | null;
  } | null;
  images?: {
    __typename?: "BookableLocationImagesConnection";
    nodes?: Array<{
      __typename?: "BookableLocationImage";
      id: string;
      image?: {__typename?: "PublicImage"; id: string} | null;
    } | null> | null;
  } | null;
  closesTodayAt?: {
    __typename?: "DetailedLocalTime";
    minuteOfHour?: string | null;
    timeHourOnly?: string | null;
    timeHourMinute?: string | null;
  } | null;
  opensNextAt?: {
    __typename?: "DetailedDateTime";
    daysFromNow?: number | null;
    dayOfWeek?: string | null;
    date?: string | null;
    minuteOfHour?: string | null;
    timeHourOnly?: string | null;
    timeHourMinute?: string | null;
  } | null;
};

export type LocationBySlugQueryVariables = Types.Exact<{
  practiceId: Types.Scalars["ID"]["input"];
  slug: Types.Scalars["String"]["input"];
}>;

export type LocationBySlugQuery = {
  __typename?: "Query";
  practice?: {
    __typename?: "Practice";
    id: string;
    location?: {
      __typename?: "BookableLocation";
      id: string;
      slug?: string | null;
      name?: string | null;
      timezone?: string | null;
      phoneNumber?: string | null;
      isOpen?: boolean | null;
      locationAddress?: {
        __typename?: "BookableLocationAddress";
        id: string;
        longitude?: number | null;
        latitude?: number | null;
        address?: {
          __typename?: "Address";
          street?: string | null;
          street2?: string | null;
          zipcode?: string | null;
          state?: Types.UsStateAbbreviation | null;
          city?: string | null;
        } | null;
      } | null;
      images?: {
        __typename?: "BookableLocationImagesConnection";
        nodes?: Array<{
          __typename?: "BookableLocationImage";
          id: string;
          image?: {__typename?: "PublicImage"; id: string} | null;
        } | null> | null;
      } | null;
      closesTodayAt?: {
        __typename?: "DetailedLocalTime";
        minuteOfHour?: string | null;
        timeHourOnly?: string | null;
        timeHourMinute?: string | null;
      } | null;
      opensNextAt?: {
        __typename?: "DetailedDateTime";
        daysFromNow?: number | null;
        dayOfWeek?: string | null;
        date?: string | null;
        minuteOfHour?: string | null;
        timeHourOnly?: string | null;
        timeHourMinute?: string | null;
      } | null;
    } | null;
  } | null;
};

export type NearbyLocationsQueryVariables = Types.Exact<{
  practiceId: Types.Scalars["ID"]["input"];
  latitude: Types.Scalars["Float"]["input"];
  longitude: Types.Scalars["Float"]["input"];
  region?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type NearbyLocationsQuery = {
  __typename?: "Query";
  practice?: {
    __typename?: "Practice";
    id: string;
    locationsNearest?: {
      __typename?: "BookableLocationsConnection";
      nodes: Array<{
        __typename?: "BookableLocation";
        id: string;
        slug?: string | null;
        name?: string | null;
        timezone?: string | null;
        phoneNumber?: string | null;
        isOpen?: boolean | null;
        locationAddress?: {
          __typename?: "BookableLocationAddress";
          id: string;
          longitude?: number | null;
          latitude?: number | null;
          address?: {
            __typename?: "Address";
            street?: string | null;
            street2?: string | null;
            zipcode?: string | null;
            state?: Types.UsStateAbbreviation | null;
            city?: string | null;
          } | null;
        } | null;
        images?: {
          __typename?: "BookableLocationImagesConnection";
          nodes?: Array<{
            __typename?: "BookableLocationImage";
            id: string;
            image?: {__typename?: "PublicImage"; id: string} | null;
          } | null> | null;
        } | null;
        closesTodayAt?: {
          __typename?: "DetailedLocalTime";
          minuteOfHour?: string | null;
          timeHourOnly?: string | null;
          timeHourMinute?: string | null;
        } | null;
        opensNextAt?: {
          __typename?: "DetailedDateTime";
          daysFromNow?: number | null;
          dayOfWeek?: string | null;
          date?: string | null;
          minuteOfHour?: string | null;
          timeHourOnly?: string | null;
          timeHourMinute?: string | null;
        } | null;
      }>;
    } | null;
  } | null;
};

export type LocationsQueryVariables = Types.Exact<{
  practiceId: Types.Scalars["ID"]["input"];
  region?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type LocationsQuery = {
  __typename?: "Query";
  practice?: {
    __typename?: "Practice";
    id: string;
    locations?: {
      __typename?: "BookableLocationsConnection";
      nodes: Array<{
        __typename?: "BookableLocation";
        id: string;
        slug?: string | null;
        name?: string | null;
        timezone?: string | null;
        phoneNumber?: string | null;
        isOpen?: boolean | null;
        locationAddress?: {
          __typename?: "BookableLocationAddress";
          id: string;
          longitude?: number | null;
          latitude?: number | null;
          address?: {
            __typename?: "Address";
            street?: string | null;
            street2?: string | null;
            zipcode?: string | null;
            state?: Types.UsStateAbbreviation | null;
            city?: string | null;
          } | null;
        } | null;
        images?: {
          __typename?: "BookableLocationImagesConnection";
          nodes?: Array<{
            __typename?: "BookableLocationImage";
            id: string;
            image?: {__typename?: "PublicImage"; id: string} | null;
          } | null> | null;
        } | null;
        closesTodayAt?: {
          __typename?: "DetailedLocalTime";
          minuteOfHour?: string | null;
          timeHourOnly?: string | null;
          timeHourMinute?: string | null;
        } | null;
        opensNextAt?: {
          __typename?: "DetailedDateTime";
          daysFromNow?: number | null;
          dayOfWeek?: string | null;
          date?: string | null;
          minuteOfHour?: string | null;
          timeHourOnly?: string | null;
          timeHourMinute?: string | null;
        } | null;
      }>;
      pageInfo: {__typename?: "PageInfo"; hasNextPage: boolean; endCursor: string};
    } | null;
  } | null;
};

export const LocationFragmentDoc = gql`
  fragment Location on BookableLocation {
    id
    slug
    name
    timezone
    phoneNumber
    locationAddress {
      id
      longitude
      latitude
      address {
        street
        street2
        zipcode
        state
        city
      }
    }
    images(first: 1) {
      nodes {
        id
        image {
          id
        }
      }
    }
    isOpen
    closesTodayAt {
      minuteOfHour: formatted(format: "m")
      timeHourOnly: formatted(format: "ha")
      timeHourMinute: formatted(format: "h:mma")
    }
    opensNextAt {
      dayOfWeek: formatted(format: "EEEE")
      date: formatted(format: "MMM d")
      minuteOfHour: formatted(format: "m")
      timeHourOnly: formatted(format: "ha")
      timeHourMinute: formatted(format: "h:mma")
      daysFromNow(timezone: "America/Los_Angeles")
    }
  }
`;
export const LocationBySlugDocument = gql`
  query LocationBySlug($practiceId: ID!, $slug: String!) {
    practice(id: $practiceId) {
      id
      location(slug: $slug) {
        ...Location
      }
    }
  }
  ${LocationFragmentDoc}
`;

/**
 * __useLocationBySlugQuery__
 *
 * To run a query within a React component, call `useLocationBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationBySlugQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useLocationBySlugQuery(
  baseOptions: Apollo.QueryHookOptions<LocationBySlugQuery, LocationBySlugQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<LocationBySlugQuery, LocationBySlugQueryVariables>(
    LocationBySlugDocument,
    options,
  );
}
export function useLocationBySlugLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LocationBySlugQuery, LocationBySlugQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<LocationBySlugQuery, LocationBySlugQueryVariables>(
    LocationBySlugDocument,
    options,
  );
}
export type LocationBySlugQueryHookResult = ReturnType<typeof useLocationBySlugQuery>;
export type LocationBySlugLazyQueryHookResult = ReturnType<typeof useLocationBySlugLazyQuery>;
export type LocationBySlugQueryResult = Apollo.QueryResult<
  LocationBySlugQuery,
  LocationBySlugQueryVariables
>;
export const NearbyLocationsDocument = gql`
  query NearbyLocations(
    $practiceId: ID!
    $latitude: Float!
    $longitude: Float!
    $region: String
    $first: Int
    $after: String
  ) {
    practice(id: $practiceId) {
      id
      locationsNearest(
        latitude: $latitude
        longitude: $longitude
        region: $region
        first: $first
        after: $after
      ) {
        nodes {
          ...Location
        }
      }
    }
  }
  ${LocationFragmentDoc}
`;

/**
 * __useNearbyLocationsQuery__
 *
 * To run a query within a React component, call `useNearbyLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNearbyLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNearbyLocationsQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      region: // value for 'region'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useNearbyLocationsQuery(
  baseOptions: Apollo.QueryHookOptions<NearbyLocationsQuery, NearbyLocationsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<NearbyLocationsQuery, NearbyLocationsQueryVariables>(
    NearbyLocationsDocument,
    options,
  );
}
export function useNearbyLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NearbyLocationsQuery, NearbyLocationsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<NearbyLocationsQuery, NearbyLocationsQueryVariables>(
    NearbyLocationsDocument,
    options,
  );
}
export type NearbyLocationsQueryHookResult = ReturnType<typeof useNearbyLocationsQuery>;
export type NearbyLocationsLazyQueryHookResult = ReturnType<typeof useNearbyLocationsLazyQuery>;
export type NearbyLocationsQueryResult = Apollo.QueryResult<
  NearbyLocationsQuery,
  NearbyLocationsQueryVariables
>;
export const LocationsDocument = gql`
  query Locations($practiceId: ID!, $region: String, $first: Int, $after: String) {
    practice(id: $practiceId) {
      id
      locations(region: $region, first: $first, after: $after) {
        nodes {
          ...Location
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
  ${LocationFragmentDoc}
`;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      practiceId: // value for 'practiceId'
 *      region: // value for 'region'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLocationsQuery(
  baseOptions: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
}
export function useLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
}
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
